import {useTranslation} from "react-i18next";
import {SecondaryButton} from "../Buttons/SecondaryButton";
import NotFoundImagePlaceholder from "../../Assets/images/illustrations/not_found_image_placeholder.svg";
import {parseStringToDateTimeWithDayjs} from "../../Utils/DateHelper";
import * as React from "react";

export const ApplicationCard = (props) => {
    const {
        application,
        onClickButton,
        canApply = false,
        imageOverride = null,
    } = props;

    const {t} = useTranslation();

    const shiftStatuten = application?.allowed_statuten?.length
        ? application.allowed_statuten
        : ['freelance'];

    const textForApplicationPossibility = application.shift_applications_possibility === 'both' ? 'VPK of ZK' : application.shift_applications_possibility === 'only_verpleegkundige' ? 'VPK' : 'ZK';

    return (
        <div className={'border border-gray-200 rounded-lg m-2'}>
            <div className={'p-4'}>
                <img src={ imageOverride !== null ? imageOverride : (application?.image ?? NotFoundImagePlaceholder) } alt={application.title} className={'w-full h-40 object-contain rounded-lg'}/>

                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('general.fields.healthcare_instiution')}: </span>
                    {(application?.branch?.alias ? application?.branch?.alias : application?.branch?.company_name ) ?? '-'}
                </p>
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('general.fields.city')}: </span>
                    {application?.branch?.city ?? '-'}
                </p>
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('shifts.available_for')}: </span>
                    {textForApplicationPossibility}
                </p>
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('general.fields.start_time')}: </span>
                    {parseStringToDateTimeWithDayjs(application.start_time)}
                </p>
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('general.fields.end_time')}:</span>
                    {parseStringToDateTimeWithDayjs(application.end_time)}
                </p>
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('shifts.break')}:</span>
                    {application.break_duration || 0} {t('shifts.minutes')}
                </p>
                {shiftStatuten.length > 0 && (
                    <p className={'font-semibold text-gray-900 mt-3 flex flex-row flex-wrap gap-2 items-center'}>
                        <span className="font-bold">{t('shifts.possible_statuten')}:</span>
                        {shiftStatuten.map(s => (
                            <span key={s} className="text-xs bg-purple-50 text-purple-800 px-2 py-0.5 rounded">
                                {t(`statuten.${s}`, s)}
                            </span>
                        ))}
                    </p>
                )}
                <p className={'font-semibold text-gray-900 mt-3 flex flex-row gap-2'}>
                    <span className="font-bold">{t('shifts.remark')}:</span>
                    {application?.remarks ?? '-'}
                </p>
                {
                    canApply ?
                            <SecondaryButton outlined={true} className={'mt-4'} onClick={onClickButton}>
                                {t('general.actions.apply')}
                            </SecondaryButton>
                    :
                        <div
                            className={'text-md text-center border border-black rounded-md py-1 text-gray-500 mt-4 select-none cursor-default'}>
                            {t('general.messages.already_applied')}
                        </div>
                }
            </div>
        </div>
    )
}